mutation addAssociation($input: AddAssociationInput!) {
  addAssociationV2(input: $input) {
    id
    tagId
    displayValue
    metadata {
      id
      name
      description
      allowedDisplayValues
      allowMultipleOnEntity
    }
    entities {
      id
      name
    }
    scope {
      id
      name
      description
    }
  }
}
